export const setThemeTo = (theme: "light" | "dark") => theme
